import DataTable from 'react-data-table-component';
export function DatasetsTable(props) {
    const { data, onEdit, onDeleteEntry } = props;

    const columns = [
        {
            name: 'Prompt',
            selector: row => row.prompt,
            sortable: true,
            width: '300px',
            maxWidth: '300px',
            minWidth: '200px',
            wrap: true
        },
        {
            name: 'Content',
            selector: row => row.content,
            sortable: true,
            width: '600px',
            maxWidth: '600px',
            minWidth: '300px',
        },
    ];

    const customStyles = {
        rows: {
            style: {
                minHeight: '50px', // override the row height
            },
        },
        headCells: {
            style: {
                paddingLeft: '8px', // override the cell padding for head cells
                paddingRight: '8px',
            },
        },
        cells: {
            style: {
                paddingLeft: '8px', // override the cell padding for data cells
                paddingRight: '8px',
            },
        },
    };

    console.log(data);
    return (
        <div className="card">
            <div className="card-body">
                <h5 className="card-title">Datasets Table</h5>
                <p className="card-text">
                    This is a visual representation of a collection of data, organized into rows and columns, that provides users with an overview of the data and allows them to interact with it.
                </p>
                <DataTable
                    columns={columns}
                    data={data}
                    pagination
                    customStyles={customStyles}
                    responsive
                    highlightOnHover
                    pointerOnHover
                    expandOnRowClicked
                    expandableRows
                    expandableRowsComponent={(props) => TableExpandableComponent(props, data, onEdit, onDeleteEntry)}
                />
            </div>
        </div>
    )
}


const TableExpandableComponent = (props, data, onEdit, onDeleteEntry) => {
    const { prompt, content, id } = props.data;
    const index = data.findIndex(obj => obj.id === id);
    return (
        <div className='table-expand-container'>
            <div class="container">
                <div class="row">
                    <div class="col-10">
                        <p class="prompt">
                            {prompt}
                        </p>
                        <p class="content">
                            {content}
                        </p>
                    </div>
                    <div class="col-2">
                        <div class="btn-group">
                            <button type="button" class="btn btn-primary btn-sm" onClick={() => onEdit(index)}>Edit</button>
                            <button type="button" class="btn btn-danger btn-sm" onClick={() => onDeleteEntry(index)}>Delete</button>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    );
}